// extracted by mini-css-extract-plugin
export default {"feedbackError":"feedbackError---c6Z0A"};